// extracted by mini-css-extract-plugin
export default {"menuList":"styles_menuList__37mUw","menuItem":"styles_menuItem__4PYCg"};